import './style/index.css';
import './style/modal.css';
import App from './components/app';

export default App;
